import React from 'react';
import { motion } from 'framer-motion';
import { Hexagon, Triangle, Circle, Square, Infinity, Diamond, Cloud, Zap } from 'lucide-react';

const clients = [
  { name: 'Acme Corp', icon: Hexagon, color: 'text-blue-500' },
  { name: 'GlobalX', icon: Triangle, color: 'text-indigo-500' },
  { name: 'NexGen', icon: Circle, color: 'text-purple-500' },
  { name: 'Vertex', icon: Square, color: 'text-emerald-500' },
  { name: 'OmniTech', icon: Infinity, color: 'text-rose-500' },
  { name: 'Stratis', icon: Diamond, color: 'text-cyan-500' },
  { name: 'CloudSync', icon: Cloud, color: 'text-sky-500' },
  { name: 'Bolt', icon: Zap, color: 'text-amber-500' },
];

const ClientLogos = () => {
  return (
    <div className="py-12 bg-white border-y border-slate-100 overflow-hidden">
      <div className="container mx-auto px-6 max-w-7xl mb-6">
        <p className="text-center text-sm font-semibold text-slate-400 uppercase tracking-wider">
          Trusted by innovative companies worldwide
        </p>
      </div>
      
      {/* Marquee Container */}
      <div className="relative flex w-full flex-nowrap overflow-hidden">
        {/* Fading edges */}
        <div className="absolute left-0 top-0 z-10 h-full w-24 bg-gradient-to-r from-white to-transparent"></div>
        <div className="absolute right-0 top-0 z-10 h-full w-24 bg-gradient-to-l from-white to-transparent"></div>

        <motion.div
          className="flex items-center gap-16 md:gap-24 whitespace-nowrap px-8"
          animate={{ x: ["0%", "-50%"] }}
          transition={{ ease: "linear", duration: 30, repeat: Infinity }}
        >
          {/* Double the list for seamless looping */}
          {[...clients, ...clients].map((client, index) => {
            const Icon = client.icon;
            return (
              <div key={index} className="flex items-center gap-3 opacity-60 hover:opacity-100 transition-opacity grayscale hover:grayscale-0 cursor-pointer">
                <Icon className={`w-8 h-8 ${client.color}`} />
                <span className="text-2xl font-bold text-slate-800 tracking-tight">{client.name}</span>
              </div>
            );
          })}
        </motion.div>
      </div>
    </div>
  );
};

export default ClientLogos;
